import { render, staticRenderFns } from "./CustomFieldsDbTableModal.vue?vue&type=template&id=44816e8e&"
import script from "./CustomFieldsDbTableModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsDbTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports